/* eslint-disable
    guard-for-in,
    no-restricted-syntax
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS202: Simplify dynamic range loops
 * DS205: Consider reworking code to avoid use of IIFEs
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import {parseNumber, sleep} from '@benchling/js-utils';
import * as Sentry from '@sentry/browser';
import {Extras} from '@sentry/types';
import {Decimal} from 'decimal.js';
import _ from 'underscore';

import {assert, assertAndContinue} from 'Asserts';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {ColumnDefinition} from 'notebook/structured-tables/columns/ColumnDefinitions';
import getColumnConstraintWithRowData from 'notebook/structured-tables/columns/getColumnConstraint';
import * as ast from 'notebook/tables/excess/AST';
import * as util from 'notebook/tables/excess/Util';
import {
  BaseCellErrors,
  BaseTypedValueType,
  Cell,
  CellIndex,
  Cells,
  ColumnConstraint,
  CustomEval,
  CustomEvalResult,
  ExternalCache,
  MultiSelectionBox,
  RowData,
  Table,
  TableColumnType,
  TypedValue,
  ValueWithError,
} from 'notebook/tables/TableConstants';
import parseTypedValue from 'notebook/tables/typed-values/parseTypedValue';
import {
  _resolveFromResolutionQueryNoWait,
  ResolutionContext,
  ResolvedValueInfo,
  resolveTypedValueWithRedux,
} from 'notebook/tables/typed-values/TypedValueResolution';
import * as logging from 'util/Logging';
import {omit} from 'util/omitKey';
import {Optional} from 'util/Types';

import {QueryResolution} from '../TableStoreTransforms';
import TableUtil from '../TableUtil';
import {
  areTypedValuesEquivalent,
  formatTypedValue,
  isBaseBoolean,
  isNumeric,
  toStringTypedValue,
} from '../typed-values/DataTypes';
import Parser from './Parser';
import Resolver from './Resolver';

/**
 * Address of a cell in a table.
 *
 * If table and/or document names are not provided then the table and document are assumed to be the current
 * table and document.
 *
 * Row: row index in table
 * Column: column index in table
 * Table: Optional name of table
 * Document: Optional name of document
 */
export interface RelativeCellAddress extends CellIndex {
  table?: string | null;
  document?: string | null;
}

/**
 * Address of a cell in a table with resolved table name and document id.
 */
export interface ResolvedCellAddress extends CellIndex {
  tableName: string;
  documentId: string;
}

/**
 * The table and document names that describe where a cell is located.
 * This is used for arguments to functions that require table and document name to be specifed.
 */
export interface TableLocationNameArgs {
  tableName: string;
  documentName: string | null;
}

// Table types in which cell errors need not be displayed
const NO_VALIDATION_TABLES = [
  ModelTypeConstants.REGISTRATION_TABLE_CONFIG,
  ModelTypeConstants.TRANSFER_TABLE_CONFIG,
  ModelTypeConstants.TRANSFER_TABLE_PLACEHOLDER,
];

// ID string to use to perform single document evaluation with the multi-doc evaluator
// Used for compatibility with document id indexed maps and document addressed cell hashing
export const PLACEHOLDER_DOC_ID = 'PLACEHOLDER_DOC_ID';

function shouldSuppressValidation(tableType: string): boolean {
  const tableTypeToKind = require('notebook/structured-tables/util/tableTypeToKind').default;

  if ((NO_VALIDATION_TABLES as Array<string>).includes(tableType)) {
    return true;
  }

  // All structured tables in templates have validation suppressed
  const {kind, isConfig} = tableTypeToKind(tableType);
  // eslint-disable-next-line benchlint/no-eqeqeq-null
  return kind !== null && isConfig;
}

export type CellNode = util.CellError | ast.ASTNode;

export type EvaluatedCellError = BaseCellErrors;

export interface EvaluatedCell {
  value: TypedValue;
  error?: EvaluatedCellError;
  locked?: boolean;
  resolutions?: Array<QueryResolution>;
  selector?: Selector | typeof util.MISSING_SELECTOR | null;
  mergedBox?: MultiSelectionBox;
}

type Settable<T> = 'unset' | T;

interface EvaluatedCellSentryInfo extends Extras {
  cellLocation: ResolvedCellAddress;
  parsedCell: Settable<{
    text: string;
    locked: boolean;
    tableType: Optional<string>;
    columnDefinition: Optional<ColumnDefinition>;
    customEvalNodes: Optional<number>;
    mergeRowSpan: Optional<number>;
    mergeColSpan: Optional<number>;
  }>;
  firstEvalResult: Settable<Optional<TypedValue>>;
  secondEvalResult: Settable<Optional<TypedValue>>;
  mergeSkippedOrHandled: boolean;
}

export function hash(cell: ResolvedCellAddress): string {
  assert(!cell.documentId.includes('|'), 'Document ID cannot contain "|"');
  // Note: it is crucial that table name be the last part of the hash string since it is a user generated string
  //  and can contain any character, including the delimiter character.
  return `${cell.documentId}|${cell.row}|${cell.column}|${cell.tableName}`;
}

export function revhash(hashed: string): ResolvedCellAddress {
  // For better performance, we index into the string instead of splitting on "|".
  const docEndIdx = hashed.indexOf('|');
  const rowEndIdx = hashed.indexOf('|', docEndIdx + 1);
  const colEndIdx = hashed.indexOf('|', rowEndIdx + 1);

  return {
    documentId: hashed.slice(0, docEndIdx),
    row: parseInt(hashed.slice(docEndIdx + 1, rowEndIdx), 10),
    column: parseInt(hashed.slice(rowEndIdx + 1, colEndIdx), 10),
    tableName: hashed.slice(colEndIdx + 1),
  };
}

class CellGraph {
  _dependents: {[parentHash: string]: {[childHash: string]: boolean}} = {};
  _dependencies: {[childHash: string]: {[parentHash: string]: boolean}} = {};

  reset(): void {
    this._dependents = {};
    this._dependencies = {};
  }

  update(cell: ResolvedCellAddress, dependencies: Array<ResolvedCellAddress>): void {
    // Wipe out old dependencies.
    const chash = hash(cell);
    const oldDependencies = this._dependencies[chash] || {};
    for (const dhash in oldDependencies) {
      delete this._dependents[dhash][chash];
    }

    // Link dependencies
    this._dependencies[chash] = {};

    for (const dependency of Array.from(dependencies)) {
      const dhash = hash(dependency);
      if (this._dependents[dhash] == null) {
        this._dependents[dhash] = {};
      }
      this._dependents[dhash][chash] = true;
      this._dependencies[chash][dhash] = true;
    }
  }

  dependencies(cell: ResolvedCellAddress): Array<ResolvedCellAddress> {
    const deps = this._dependencies[hash(cell)];
    return (() => {
      const result = [];
      for (const dhash in deps) {
        result.push(revhash(dhash));
      }
      return result;
    })();
  }

  dependents(cell: ResolvedCellAddress): Array<ResolvedCellAddress> {
    const deps = this._dependents[hash(cell)];
    return (() => {
      const result = [];
      for (const dhash in deps) {
        result.push(revhash(dhash));
      }
      return result;
    })();
  }
}

type StatesKey = 'visited' | 'visiting';

class CellGraphTraverser {
  getAdj: (cell: ResolvedCellAddress) => Array<ResolvedCellAddress>;
  onVisit: (cell: ResolvedCellAddress) => void;
  onCycle: (cell: ResolvedCellAddress) => void;
  states: {
    visited: {[cellHash: string]: ResolvedCellAddress};
    visiting: {[cellHash: string]: ResolvedCellAddress};
  };
  constructor({
    getAdj,
    onVisit,
    onCycle,
  }: {
    getAdj: (cell: ResolvedCellAddress) => Array<ResolvedCellAddress>;
    onVisit: (cell: ResolvedCellAddress) => void;
    onCycle: (cell: ResolvedCellAddress) => void;
  }) {
    this.getAdj = getAdj;
    this.onVisit = onVisit;
    this.onCycle = onCycle;
    this.states = {visited: {}, visiting: {}};
  }

  reset(): void {
    this.states = {
      visited: {},
      visiting: {},
    };
  }

  marked(cell: ResolvedCellAddress, state: StatesKey): boolean {
    // eslint-disable-next-line benchlint/no-in-operator
    return hash(cell) in this.states[state];
  }

  mark(cell: ResolvedCellAddress, state: StatesKey): void {
    this.states[state][hash(cell)] = cell;
  }

  unmark(cell: ResolvedCellAddress, state: StatesKey): void {
    delete this.states[state][hash(cell)];
  }

  visit(cell: ResolvedCellAddress): void {
    // DFS approach to traversing dependencies in topological order.
    if (this.marked(cell, 'visiting')) {
      if (typeof this.onCycle === 'function') {
        this.onCycle(cell);
      }
      return;
    }
    if (!this.marked(cell, 'visited')) {
      this.mark(cell, 'visiting');
      for (const adjCell of Array.from(this.getAdj(cell))) {
        this.visit(adjCell);
      }
      this.unmark(cell, 'visiting');
      this.mark(cell, 'visited');
      if (typeof this.onVisit === 'function') {
        this.onVisit(cell);
      }
    }
  }
}

export class Environment {
  currentTable: string | null = null;
  currentDocumentId: string | null = null;
  _env: {[cellHash: string]: ValueWithError} = {};
  rowData: RowData | null = null;
  externalCache: ExternalCache | null = null;
  tableType?: string | null = null;
  fullTableMap: MultidocFullTableMap = {};
  _mergeCellIntermediateResults: {[cellHash: string]: TypedValue} = {};
  documentNameToIds: {[documentName: string]: Array<string>} = {};

  reset(): void {
    // Mapping of cell ID hash to {value, error} object.
    this._env = {};
    this.currentTable = null;
    this.currentDocumentId = null;
  }

  getNullableDocumentId(documentName: string): string | null {
    const matchingDocuments = this.documentNameToIds[documentName] ?? [];
    if (matchingDocuments.length !== 1) {
      return null;
    }
    return matchingDocuments[0];
  }

  getDocumentId(documentName: string): string {
    const matchingDocuments = this.documentNameToIds[documentName] ?? [];
    if (matchingDocuments.length === 0) {
      throw new util.ReferenceError(`Unresolved name: ${documentName}`);
    } else if (matchingDocuments.length > 1) {
      throw new util.ReferenceError(`Multiple steps with name: ${documentName}`);
    }
    return matchingDocuments[0];
  }

  /**
   * Get the value and any possible errors from a cell. Generally using get is recommended instead since it
   * will automatically throw any errors found.
   */
  getValueWithError(id: RelativeCellAddress): ValueWithError {
    assert(this.currentTable != null, 'Expected currentTable to be defined');
    assert(this.currentDocumentId != null, 'Expected currentDocumentId to be defined');
    assert(id.table != null || id.document == null, 'Expected document to be null if table is null');
    const resolvedTableName = id.table == null ? this.currentTable : id.table;
    const resolvedDocId = id.document == null ? this.currentDocumentId : this.getDocumentId(id.document);

    const resolvedAddress: ResolvedCellAddress = {
      tableName: resolvedTableName,
      documentId: resolvedDocId,
      row: id.row,
      column: id.column,
    };

    return this._env[hash(resolvedAddress)];
  }

  get(id: RelativeCellAddress): TypedValue {
    // Returns value of cell or throws error associated with desired cell.
    const {value, error} = this.getValueWithError(id);
    if (value) {
      // If we happen to have an error value for the cell, throw it.
      util.throwOnErrorTypedValue(value);
      return value;
    } else {
      assertAndContinue(Boolean(error), 'Expected one of value or error from an evaluation result.');
      throw error;
    }
  }

  put(id: ResolvedCellAddress, value: ValueWithError): void {
    this._env[hash(id)] = value;
  }

  putParentMergeCellIntermediateEvalResult(cellId: ResolvedCellAddress, value: TypedValue): void {
    this._mergeCellIntermediateResults[hash(cellId)] = value;
  }

  getParentMergeCellIntermediateEvalResult(cellId: ResolvedCellAddress): TypedValue {
    // If the parent cell contains a #REF! error, it will not have a value in the map.
    // Passing back an empty typed value is safe because the parent error will always take precedence.
    return this._mergeCellIntermediateResults[hash(cellId)] ?? toStringTypedValue('');
  }

  output(id: ResolvedCellAddress): EvaluatedCell {
    const {value, error, locked, resolutions} = this._env[hash(id)];

    if (value != null) {
      // Either just a value or a combination value and error.
      return {
        value,
        ...(error && {error: util.getErrorOutput(error)}),
        locked,
        ...(resolutions ? {resolutions} : {}),
      };
    } else {
      return {
        value: util.astValue({
          rawValue: util.getErrorText(error),
          type: BaseTypedValueType.STRING,
        }),
        error: util.getErrorOutput(error),
        locked,
        ...(resolutions ? {resolutions} : {}),
      };
    }
  }
}

export interface MultidocFullTableMap {
  [docId: string]: FullTableMap;
}
export interface MultidocOutputTableMap {
  [docId: string]: OutputTableMap;
}

export interface FullTableMap {
  [tableName: string]: Table;
}

/**
 * A nested set of arrays containing the evaluated cells. The outer array indexes on rows, and the inner
 * array indexes on columns
 *
 * e.g.: EvaluatedTable[rowIndex][columnIndex]
 */
export type EvaluatedTable = Array<Array<EvaluatedCell>>;

export interface OutputTableMap {
  [tableName: string]: EvaluatedTable;
}

export interface Selector {
  name: string;
  staticId: string;
  options: Array<string>;
}

interface ParsedCell<CustomEvalOptions = unknown> {
  text: string;
  locked: boolean;
  tableType: Optional<string>;
  node: CellNode;
  selector: Selector | typeof util.MISSING_SELECTOR | null;
  externalCache: ExternalCache | null;
  rowData: RowData | null;
  columnDefinition: Optional<ColumnDefinition>;
  customEval?: CustomEval<CustomEvalOptions>;
  customEvalNodes?: Array<CellNode | null>;
  customEvalOptions?: CustomEvalOptions;
  mergeRowSpan: Optional<number>;
  mergeColSpan: Optional<number>;
  parentMergeCell: Optional<ResolvedCellAddress>;
}

function isParentMergeCell(parsedCell: ParsedCell): boolean {
  return (
    (parsedCell.mergeRowSpan != null && parsedCell.mergeRowSpan > 1) ||
    (parsedCell.mergeColSpan != null && parsedCell.mergeColSpan > 1)
  );
}

function isChildMergeCell(parsedCell: ParsedCell): boolean {
  return parsedCell.parentMergeCell != null;
}

/**
 * Perform Excel-like evaluation on a multi-document map of tables.
 *
 * Note that Cell.customEvalArgs is always parsed with `Parser.parse` even if `Parser.parseAsValue` is
 * specified as the `parse` passed into the SpreadsheetEvaluator constructor. This allows a developer
 * to reference cells via customEvalArgs even in a table that does not support user-defined formulas.
 */
export class MultiDocSpreadsheetEvaluator {
  parse: (text: string) => ast.ASTNode;
  graph: CellGraph;
  env: Environment;
  evaluator: CellGraphTraverser;
  docSelectors: Map<string, {[staticId: string]: Selector}>;
  docTables: {[docId: string]: {[tableName: string]: Array<Array<ParsedCell>>}};
  docResolvers: Map<string, Resolver> | null;
  primaryFileId: string | null; // The document that triggered evaluation. This should only be used for metrics.

  constructor({
    fullTableMap,
    selectors,
    parse,
    resolvers = null,
    primaryFileId = null,
    documentNameToIds = {},
  }: {
    fullTableMap: MultidocFullTableMap;
    parse: (text: string) => ast.ASTNode;
    selectors?: Map<string, Array<Selector>>;
    resolvers?: Optional<Map<string, Resolver>>;
    primaryFileId?: Optional<string>;
    documentNameToIds?: {[documentName: string]: Array<string>};
  }) {
    this.docResolvers = resolvers;
    this.parse = parse;
    this.graph = new CellGraph();
    this.env = new Environment();
    this.primaryFileId = primaryFileId;
    this.env.fullTableMap = fullTableMap;
    this.env.documentNameToIds = documentNameToIds;

    // Make cell evaluator
    const getAdj = (cell: ResolvedCellAddress): Array<ResolvedCellAddress> =>
      this.graph.dependencies(cell) || {};
    const onVisit = (cell: ResolvedCellAddress): void => {
      this._evaluateCell(cell);
    };
    const onCycle = (cell: ResolvedCellAddress): void => {
      this.env.put(cell, {
        value: null,
        error: new util.ReferenceError('Circular dependency detected'),
        locked: false,
      });
    };
    this.evaluator = new CellGraphTraverser({getAdj, onVisit, onCycle});

    // Parse selectors into dict.
    this.docSelectors = this._normalizeSelectors(selectors);
    // Process initial documents into nodes.
    this.docTables = {};
    for (const docId in fullTableMap) {
      this.docTables[docId] = {};
      for (const tableName in fullTableMap[docId]) {
        this._buildTable(docId, tableName, fullTableMap[docId][tableName]);
      }
    }
  }

  _normalizeSelectors(
    selectorArrays: Map<string, Array<Selector>> | undefined
  ): Map<string, {[staticId: string]: Selector}> {
    const result = new Map();
    if (selectorArrays != null) {
      selectorArrays.forEach((selectors, docId) => {
        result.set(docId, _.indexBy(selectors, 'staticId'));
      });
    }
    return result;
  }

  _processDeps(
    parsedCell: ParsedCell,
    currentTable: string,
    currentDocumentId: string
  ): Array<ResolvedCellAddress> {
    if (parsedCell.node instanceof util.CellError) {
      return [];
    }

    // _processDeps is a hot codepath. In most cases, a table cell will be an explicit value.
    // If we can detect this case, we can quickly return that there are no deps.
    if (!parsedCell.customEvalNodes && !parsedCell.parentMergeCell && parsedCell.node instanceof ast.Value) {
      const deps = parsedCell.node.dependencies(this.env);
      if (deps.size === 0) {
        return [];
      }
    }

    this.env.currentTable = currentTable;
    this.env.currentDocumentId = currentDocumentId;

    const nestedNodes = parsedCell.customEvalNodes ? parsedCell.customEvalNodes : [];
    const nodes = [parsedCell.node, ...nestedNodes].filter((node) => node != null);
    // TODO: customEvalNodes could actually be a util.CellError, but we expect customEvalArgs to
    // always be validly defined, as they are not user-defined. See skipped test in Excess-test.js.
    const deps = nodes.map((node: ast.ASTNode) => Array.from(node.dependencies(this.env))).flat();

    // ensure parent cell in merge range is evaluated prior to child cells
    if (parsedCell.parentMergeCell) {
      deps.push(parsedCell.parentMergeCell);
    }

    const resolvedDeps: Array<ResolvedCellAddress> = [];
    for (const dep of deps) {
      const documentId = dep.document ? this.env.getNullableDocumentId(dep.document) : currentDocumentId;
      if (documentId != null) {
        resolvedDeps.push({
          ...dep,
          tableName: dep.table || currentTable,
          documentId,
        });
      }
    }
    return resolvedDeps;
  }

  _buildTableNodeAndUpdateGraph(
    fullTable: Table,
    table: Cells,
    docId: string,
    tableName: string,
    coordinate: {rowIndex: number; columnIndex: number},
    mergeCells: Map<ResolvedCellAddress, ParsedCell>,
    rowDataList: Optional<Array<RowData>>
  ): ParsedCell {
    let selector;
    const i = coordinate.rowIndex;
    const j = coordinate.columnIndex;
    const row = table[i];
    const cell = row[j];
    const {selectorId, mergeRowSpan, mergeColSpan, externalCache} = cell;
    if (selectorId != null) {
      // We look up selector by selectorId, falling back to util.MISSING_SELECTOR to indicate that
      // selectorId was specified by the selector but could not be found.
      const selectors = this.docSelectors.get(docId);
      selector =
        selectors != null && selectors[selectorId] != null ? selectors[selectorId] : util.MISSING_SELECTOR;
    } else {
      selector = null;
    }
    const rowData = rowDataList == null ? null : rowDataList[i];
    const columnConstraint =
      fullTable.columnConstraints && getColumnConstraintWithRowData(fullTable.columnConstraints[j], rowData);
    let parentMergeCell: ResolvedCellAddress | null = null;
    for (const [cellId, parsedCell] of mergeCells.entries()) {
      if (
        i >= cellId.row &&
        i < cellId.row + (parsedCell.mergeRowSpan ?? 1) &&
        j >= cellId.column &&
        j < cellId.column + (parsedCell.mergeColSpan ?? 1)
      ) {
        parentMergeCell = cellId;
        break;
      }
    }

    const parsedCell = this._parseFormula({
      cell,
      columnConstraints: fullTable.columnConstraints,
      rowIndex: i,
      colIndex: j,
    });

    const augmentedCell: ParsedCell = {
      ...parsedCell,
      tableType: fullTable._tableType,
      // Attach selector to cell for output to use.
      selector,
      rowData,
      externalCache: externalCache == null ? null : externalCache,
      columnDefinition: columnConstraint && columnConstraint.columnDefinition,
      ...(!cell.customEvalArgs || !cell.customEval
        ? {}
        : {
            customEval: cell.customEval,
            customEvalNodes: cell.customEvalArgs.map((customEvalArg) =>
              // eslint-disable-next-line benchlint/no-eqeqeq-null
              customEvalArg !== null ? this._parseFormulaText(customEvalArg, {forCustomEval: true}) : null
            ),
            customEvalOptions: cell.customEvalOptions,
          }),
      mergeRowSpan,
      mergeColSpan,
      parentMergeCell,
    };

    if (isParentMergeCell(augmentedCell)) {
      mergeCells.set({row: i, column: j, tableName, documentId: docId}, augmentedCell);
    }
    const dependencies = this._processDeps(augmentedCell, tableName, docId);
    this.graph.update({tableName, documentId: docId, row: i, column: j}, dependencies);
    return augmentedCell;
  }

  _buildTable(docId: string, tableName: string, fullTable: Table): void {
    const {table, rowData: rowDataList} = fullTable;
    const mergeCells = new Map<ResolvedCellAddress, ParsedCell>();
    this.docTables[docId][tableName] = table.map((row, i) => {
      const result: Array<ParsedCell> = [];
      for (let j = 0; j < row.length; j++) {
        const parsedCell = this._buildTableNodeAndUpdateGraph(
          fullTable,
          table,
          docId,
          tableName,
          {rowIndex: i, columnIndex: j},
          mergeCells,
          rowDataList
        );
        result.push(parsedCell);
      }
      return result;
    });
  }

  _parseFormulaText(text: string, {forCustomEval = false}: {forCustomEval?: boolean} = {}): CellNode {
    try {
      // this.parse may be Parse.parseAsValue (no formulas) vs Parser.parse (handles formulas).
      // For custom eval, a developer should always be able to use formulas as a way to reference other
      // columns, so we ignore this.parse in favor of Parser.parse.
      if (forCustomEval) {
        return Parser.parse(text);
      }
      return this.parse(text);
      // eslint-disable-next-line benchlint/always-throw-from-catch
    } catch (e) {
      if (e instanceof util.FormulaParseError || e instanceof util.FormulaTokenizeError) {
        return e;
      } else {
        logging.error(e, {extra: {formula: text}});
        return new util.CellError('Unexpected error occurred');
      }
    }
  }

  _parseFormula({
    cell,
    columnConstraints,
    rowIndex,
    colIndex,
  }: {
    cell: Cell;
    columnConstraints: Array<ColumnConstraint | null> | null;
    rowIndex: number;
    colIndex: number;
  }): {node: CellNode; text: string; locked: boolean} {
    const text = cell.text;
    const locked = cell.locked || TableUtil.isColumnLocked(columnConstraints && columnConstraints[colIndex]);
    if (!text || util.getFormulaText(text) == null) {
      const typedValue = parseTypedValue(cell, columnConstraints && columnConstraints[colIndex]);
      if (typedValue != null) {
        return {
          node: new ast.Value(typedValue),
          text: '',
          locked: Boolean(locked),
        };
      }
    }

    const node = this._parseFormulaText(text);
    if (node instanceof ast.ASTNode && node.prepareChildren != null) {
      const columnDefinitions =
        columnConstraints &&
        columnConstraints.map(
          (columnConstraint) => (columnConstraint && columnConstraint.columnDefinition) || null
        );

      node.prepareChildren(rowIndex, columnDefinitions);
    }

    return {
      node,
      text,
      locked: Boolean(locked),
    };
  }

  /**
   * Evaluate the given cell and attach the result typedValue or Error to the evaluation environment.
   *
   * @param cell a {table, row, column} object representing the string table name and integer row
   *   and column indices.
   */
  _evaluateCell(cellId: ResolvedCellAddress): void {
    this.env.put(cellId, this._getEvaluatedCell(cellId));
  }

  _setupEvaluatedCellSentryInfo(cellId: ResolvedCellAddress): EvaluatedCellSentryInfo {
    // Some values get assigned a valid null or undefined, so we use the literal string 'unset' to denote
    // something that never got set, generally because the error was thrown before the line where it would
    // normally have been set.
    return {
      cellLocation: cellId,
      parsedCell: 'unset',
      firstEvalResult: 'unset',
      secondEvalResult: 'unset',
      mergeSkippedOrHandled: false,
    };
  }

  _shapeParsedCellToSentryInfo(parsedCell: ParsedCell<unknown>): EvaluatedCellSentryInfo['parsedCell'] {
    return {
      text: parsedCell.text,
      locked: parsedCell.locked,
      tableType: parsedCell.tableType,
      columnDefinition: parsedCell.columnDefinition,
      customEvalNodes: parsedCell.customEvalNodes?.length,
      mergeRowSpan: parsedCell.mergeRowSpan,
      mergeColSpan: parsedCell.mergeColSpan,
    };
  }

  /**
   * Evaluate a cell and return a {value, error} object, where at least one of value and error is
   * non-null.
   */
  _getEvaluatedCell(cellId: ResolvedCellAddress): ValueWithError {
    const {documentId, tableName: table, row, column} = cellId;
    // Establish error info that we can update as the try block proceeds.
    const errorInfo: EvaluatedCellSentryInfo = this._setupEvaluatedCellSentryInfo(cellId);
    let locked = false;
    try {
      // eslint-disable-next-line benchlint/no-in-operator
      if (!(documentId in this.docTables)) {
        throw new util.ReferenceError(`Unresolved name '${documentId}'.`);
      }
      // eslint-disable-next-line benchlint/no-in-operator
      if (!(table in this.docTables[documentId])) {
        throw new util.ReferenceError(`Unresolved sheet name '${table}'.`);
      }

      if (
        this.docTables[documentId][table][row] != null &&
        this.docTables[documentId][table][row][column] != null
      ) {
        this.env.currentTable = table;
        this.env.currentDocumentId = documentId;
        const parsedCell = this.docTables[documentId][table][row][column];
        errorInfo.parsedCell = this._shapeParsedCellToSentryInfo(parsedCell);
        const {node, externalCache, rowData, tableType, columnDefinition} = parsedCell;
        locked = Boolean(parsedCell.locked);
        this.env.rowData = rowData;
        this.env.externalCache = externalCache;
        this.env.tableType = tableType;

        // short circuit on parse errors
        if (node instanceof util.CellError) {
          return {value: null, error: node, locked};
        }

        // run cell eval
        let val: TypedValue | null = postProcessNumericTypedValues(node.eval(this.env));
        // We should never actually have an ErrorTypedValue make it beyond this point. Throw it if we have one.
        util.throwOnErrorTypedValue(val);
        errorInfo.firstEvalResult = val;
        let error: BaseCellErrors | null = null;
        let shouldSkipValidation = false;

        // Handle merge cell behavior. Parent (top left) merge cells store their intermediate eval result for
        // use by children. Child merge cells (all cells in range that are NOT top left) use the
        // intermediate result of their parent cells as input to second stage eval for the purpose of
        // surfacing custom eval/resolution-related errors.
        if (isParentMergeCell(parsedCell)) {
          this.env.putParentMergeCellIntermediateEvalResult(cellId, val);
        } else if (isChildMergeCell(parsedCell)) {
          return this.handleChildMergeCellResolution(cellId, parsedCell, val);
        }
        errorInfo.mergeSkippedOrHandled = true;

        // run custom eval (if defined) and resolution
        ({val, error, locked, shouldSkipValidation} = this.runSecondStageEvaluationForCell(
          cellId,
          parsedCell,
          val
        ));
        errorInfo.secondEvalResult = val;

        const resolutions = this.docResolvers
          ?.get(cellId.documentId)
          ?.getQueryResolutionsForCell(hash(cellId));

        if (shouldSkipValidation) {
          error = null;
        }
        if (columnDefinition && columnDefinition.type === TableColumnType.MISSING_FIELD) {
          locked = true;
        }

        if (val || error) {
          return {
            value: val,
            error,
            locked,
            ...(resolutions ? {resolutions} : {}),
          } as ValueWithError;
        }
        return {
          value: util.astValue({rawValue: '', type: BaseTypedValueType.STRING}),
          error,
          locked,
          ...(resolutions ? {resolutions} : {}),
        };
      } else {
        return {
          value: util.astValue({rawValue: '', type: BaseTypedValueType.STRING}),
          error: null,
          locked,
        };
      }
      // eslint-disable-next-line benchlint/always-throw-from-catch
    } catch (e) {
      if (e instanceof util.CellError) {
        return {value: null, error: e, locked};
      } else {
        Sentry.getCurrentScope().setTransactionName('TableEvaluation');
        logging.error(e, {
          extra: errorInfo,
        });
        return {value: null, error: new util.CellError('Unexpected error occurred'), locked};
      }
    }
  }

  /**
   * For the specified cell and input values, run custom eval function if defined, perform any selector
   * validation, and resolve the final cell value based on the column definition.
   */
  private runSecondStageEvaluationForCell(
    cellId: ResolvedCellAddress,
    parsedCell: ParsedCell<unknown>,
    inputValue: TypedValue
  ): {
    val: TypedValue | null;
    error: BaseCellErrors | null;
    locked: boolean;
    shouldSkipValidation: boolean;
  } {
    const {selector, columnDefinition} = parsedCell;
    let val: TypedValue | null = inputValue;
    let error: BaseCellErrors | null = null;
    let shouldSkipValidation = this.env.tableType != null && shouldSuppressValidation(this.env.tableType);
    let locked = parsedCell.locked;

    if (parsedCell.customEval) {
      const customEvalResult = this.runCustomEvalForCell(cellId, parsedCell, inputValue);
      val = customEvalResult.val;
      error = customEvalResult.error;
      locked = locked || customEvalResult.locked;
      shouldSkipValidation = shouldSkipValidation || Boolean(customEvalResult.shouldSkipValidation);
    }

    // Skip selector validation and typed value resolution if there is already an error
    if (!error || !util.hasInvalidCellError(error)) {
      if (selector != null) {
        const selectorValidationResult = this.validateSelector(selector, val);
        val = selectorValidationResult.val;
        error = error || selectorValidationResult.error;
      } else if (columnDefinition) {
        const resolvedValueInfo = this.resolveTypedValueForCell(cellId, parsedCell, val);
        val = resolvedValueInfo.resolvedValue;
        error = error || resolvedValueInfo.error;
      }
    }
    return {val, error, locked, shouldSkipValidation};
  }

  /**
   * Perform selector validation as required for the input value.
   */
  validateSelector(
    selector: Selector | typeof util.MISSING_SELECTOR | null,
    inputValue: TypedValue | null
  ): {val: TypedValue | null; error: util.CellError | null} {
    if (selector === util.MISSING_SELECTOR) {
      return {
        val: null,
        error: new util.NameError('Selector has been deleted - set another or press delete to clear'),
      };
    }
    if (
      selector != null &&
      !(selector as Selector).options.some(
        (option) =>
          (inputValue != null &&
            isNumeric(inputValue) &&
            parseNumber(option) &&
            new Decimal(option.trim()).equals(new Decimal(formatTypedValue(inputValue)))) ||
          (inputValue != null &&
            isBaseBoolean(inputValue) &&
            ['false', 'true'].includes(option.toLowerCase()) &&
            option.toLowerCase() === formatTypedValue(inputValue).toLowerCase()) ||
          (inputValue != null && option === formatTypedValue(inputValue))
      )
    ) {
      return {
        val: inputValue,
        error: new util.ValueError("Cell value is invalid - must match one of the selector's options"),
      };
    }

    return {val: inputValue, error: null};
  }

  /**
   * Perform typed value resolution on the specified value for the specified cell, given its table type and
   * column definition.
   */
  resolveTypedValueForCell(
    cellId: ResolvedCellAddress,
    parsedCell: ParsedCell,
    inputValue: TypedValue | null
  ): ResolvedValueInfo {
    const {text, tableType, columnDefinition} = parsedCell;
    assert(columnDefinition != null, 'Expected columnDefinition to be defined');

    // TODO(BNCH-98733): After verifying that this assert is not being triggered, remove it
    // and more gracefully/robustly handle null (currently just casting to preserve existing behavior)
    assertAndContinue(inputValue != null, 'Expected TypedValue to not be null during resolution stage', {
      cellId: hash(cellId),
    });
    const typedValue = inputValue as TypedValue;

    const hasFormula = Boolean(util.getFormulaText(text));
    const options: ResolutionContext = {
      tableType,
      hasFormula,
      fileId: cellId.documentId !== PLACEHOLDER_DOC_ID ? cellId.documentId : undefined,
    };
    return this.docResolvers
      ? this.docResolvers.get(cellId.documentId)!.getResolveTypedValueFnForCell(hash(cellId))(
          columnDefinition,
          typedValue,
          options
        )
      : resolveTypedValueWithRedux(columnDefinition, typedValue, options);
  }

  runCustomEvalForCell(
    cellId: ResolvedCellAddress,
    parsedCell: ParsedCell,
    inputValue: TypedValue
  ): CustomEvalResult {
    const {customEval, customEvalNodes, customEvalOptions, columnDefinition} = parsedCell;
    assert(customEval != null, 'Expected customEval to be defined');
    return customEval(
      inputValue,
      columnDefinition,
      // TODO: customEvalNodes could actually be a util.CellError, but we expect customEvalArgs to
      // always be validly defined, as they are not user-defined. See skipped test in Excess-test.js.
      customEvalNodes!.map((customEvalNode) =>
        // eslint-disable-next-line benchlint/no-eqeqeq-null
        customEvalNode !== null ? (customEvalNode as ast.ASTNode).eval(this.env) : null
      ),
      customEvalOptions,
      this.docResolvers
        ? this.docResolvers.get(cellId.documentId)!.getResolveQueryFnForCell(hash(cellId))
        : _resolveFromResolutionQueryNoWait,
      this.docResolvers
        ? this.docResolvers.get(cellId.documentId)!.getResolveTypedValueFnForCell(hash(cellId))
        : resolveTypedValueWithRedux,
      cellId.documentId !== PLACEHOLDER_DOC_ID ? cellId.documentId : null
    );
  }

  /**
   * Performs second stage evaluation for a child cell in a merged range using the intermediate evaluation
   * result from the parent cell in the range. The result of this operation is not applied to the cell, but
   * used to determine if the custom eval function (if present) causes a difference in value between
   * merged cells. This outcome results in an error prompting the user to unmerge the range. The error value
   * will also be inspected downstream to ensure that errors in child cells are not hidden.
   *
   * @param cellId The child cell ID
   * @param parsedCell The child ParsedCell
   * @param val The child cell's intermediate evaluation result, which will be applied to the return value
   * @returns The child cell evaluation result with modified error logic
   */
  handleChildMergeCellResolution(
    cellId: ResolvedCellAddress,
    parsedCell: ParsedCell<unknown>,
    val: TypedValue
  ): ValueWithError {
    assert(parsedCell.parentMergeCell != null, 'Expected parentMergeCell to exist');

    const {
      val: childVal,
      error: childError,
      locked: childLocked,
    } = this.runSecondStageEvaluationForCell(
      cellId,
      parsedCell,
      this.env.getParentMergeCellIntermediateEvalResult(parsedCell.parentMergeCell)
    );
    const parentCell = this.env.getValueWithError(parsedCell.parentMergeCell);
    if (util.hasErrorType(childError, util.LoadingError.type)) {
      return {
        value: val,
        error: childError,
        locked: childLocked,
      };
    } else if (!areTypedValuesEquivalent(parentCell.value, childVal) || parentCell.locked !== childLocked) {
      return {
        value: val,
        error: util.addError(childError, new util.MergeError('Range must be unmerged')),
        locked: childLocked,
      };
    } else if (parentCell.error == null && childError != null) {
      return {
        value: val,
        error: childError,
        locked: childLocked,
      };
    } else {
      return {
        value: val,
        error: null,
        locked: childLocked,
      };
    }
  }

  // Helper function for setting the mergedBox property (bounding box) for all merged cells.
  _tagMergedCells(rv: MultidocOutputTableMap): void {
    for (const docId in this.docTables) {
      const tables = this.docTables[docId];
      for (const name in tables) {
        const table = tables[name];
        for (let i = 0; i < table.length; i++) {
          const row = table[i];
          for (let j = 0; j < row.length; j++) {
            const {mergeRowSpan, mergeColSpan} = row[j];
            const rowSpan = mergeRowSpan != null ? mergeRowSpan : 1;
            const colSpan = mergeColSpan != null ? mergeColSpan : 1;
            if (rowSpan === 1 && colSpan === 1) {
              continue;
            }

            const parent = rv[docId][name][i][j];
            // Sets the mergedBox property and the evaluated value.
            let bubbledError = parent.error ?? null;
            for (let s = i; s < i + rowSpan; s++) {
              for (let t = j; t < j + colSpan; t++) {
                const child = rv[docId][name][s][t];
                child.mergedBox = {
                  minI: i,
                  maxI: i + rowSpan - 1,
                  minJ: j,
                  maxJ: j + colSpan - 1,
                };
                // Set value to be the same for all cells in the merged range
                // Errors need to be post-processed in order to a) bubble child cell errors up to the parent,
                // and b) propagate parent cell error to children in order to power row error indicators.
                if (!(s === i && t === j)) {
                  child.value = parent.value;
                  if (child.error != null) {
                    bubbledError = util.computeBubbledError(child.error, bubbledError) ?? null;
                  }
                  child.error = parent.error;
                  if (child.error === undefined) {
                    rv[docId][name][s][t] = omit(child, 'error');
                  }
                }
              }
            }

            if (bubbledError != null) {
              for (let s = i; s < i + rowSpan; s++) {
                for (let t = j; t < j + colSpan; t++) {
                  rv[docId][name][s][t].error = bubbledError;
                }
              }
            }
          }
        }
      }
    }
  }

  _output(): MultidocOutputTableMap {
    const rv: MultidocOutputTableMap = {};
    for (const docId in this.docTables) {
      rv[docId] = {};
      const tables = this.docTables[docId];
      for (const name in tables) {
        const table = tables[name];
        rv[docId][name] = _.map(table, (row, i) =>
          _.map(row, (cell, j) => {
            const id = {documentId: docId, tableName: name, row: i, column: j};
            this.evaluator.visit(id);
            const out = this.env.output(id);
            // Copy selector from cell.
            out.selector = cell.selector;
            return out;
          })
        );
      }
    }

    return rv;
  }

  output(): MultidocOutputTableMap {
    this.env.reset();
    this.evaluator.reset();
    const rv = this._output();
    this._tagMergedCells(rv);
    return rv;
  }

  async outputWithStringsResolved({
    timeoutSeconds = 120,
  }: {timeoutSeconds?: number} = {}): Promise<MultidocOutputTableMap> {
    for (let i = 0; i < timeoutSeconds; i++) {
      const outputTableMap = this.output();
      if (Object.keys(outputTableMap).every((docId) => !util.hasLoadingCells(outputTableMap[docId]))) {
        return outputTableMap;
      }
      await sleep(1000);
    }
    throw new Error('String resolution timed out.');
  }
}

/*
 * Wrapper class to perform single document evaluation with the multi-doc evaluator.
 */
export class SingleDocSpreadsheetEvaluator {
  public multidocEvaluator: MultiDocSpreadsheetEvaluator;
  private fileId: string;

  constructor({
    fullTableMap,
    selectors,
    parse,
    resolver = null,
    fileId = null,
  }: {
    fullTableMap: FullTableMap;
    parse: (text: string) => ast.ASTNode;
    selectors?: Array<Selector>;
    resolver?: Optional<Resolver>;
    fileId?: Optional<string>;
  }) {
    this.fileId = fileId ?? PLACEHOLDER_DOC_ID;
    const multidocTableMap: MultidocFullTableMap = {
      [this.fileId]: fullTableMap,
    };

    const multidocSelectors: Map<string, Array<Selector>> | undefined = selectors
      ? new Map([[this.fileId, selectors]])
      : undefined;

    const multidocResolvers = resolver ? new Map([[this.fileId, resolver]]) : undefined;

    this.multidocEvaluator = new MultiDocSpreadsheetEvaluator({
      fullTableMap: multidocTableMap,
      selectors: multidocSelectors,
      parse,
      resolvers: multidocResolvers,
      primaryFileId: this.fileId,
    });
  }

  output(): OutputTableMap {
    const multidocOutput = this.multidocEvaluator.output();
    return multidocOutput[this.fileId];
  }

  async outputWithStringsResolved(options?: {timeoutSeconds?: number}): Promise<OutputTableMap> {
    const multidocOutput = await this.multidocEvaluator.outputWithStringsResolved(options);
    return multidocOutput[this.fileId];
  }
}

/**
 * Post-process the typed value output of cell evaluation, performing any modifications that should only
 * occur after all evaluation flow has run.
 *
 * Currently, the only post-processing that happens is normalization for the output of numerical calculation.
 * This consists of rounding raw numeric values to a maximum number of significant digits we support.
 *
 * @param val the TypedValue output from a single table cell, or null if no output.
 */
function postProcessNumericTypedValues(val: TypedValue): TypedValue {
  if (val.type === BaseTypedValueType.NUMBER || val.type === BaseTypedValueType.SCIENTIFIC) {
    val = {...val, rawValue: util.capMaxFloatDecimalDigits(val.rawValue)};
  }

  return val;
}
